//swatch stuff for card components

document.addEventListener('click', (event) => {
  if( event.target.classList.contains( 'swatch-input' ) ) {
    let radioButton = event.target;
    let productCard = radioButton.closest( '.grid__item' );
    let productLinks = productCard.querySelectorAll( 'a' );
    
    let productHref = new URL(productLinks[0].href);
    let linkParams = productHref.searchParams;
    linkParams.set( 'variant', radioButton.dataset.variantId );
    productHref.search = linkParams.toString();
    productLinks.forEach((productLink) =>
      productLink.href = productHref
    );
    
    let activeImages = productCard.querySelectorAll( '.card__media img.active' );
    let newActiveImages = productCard.querySelectorAll( '.image-id-' + radioButton.dataset.variantImageId );
    activeImages.forEach((image) =>
      image.classList.remove( 'active' )
    );
    newActiveImages.forEach((image) =>
      image.classList.add( 'active' )
    );
  }
});

window.addEventListener("load", (event) => {
  const productInfoWrapper = document.querySelector( '.product__info-wrapper' );
  if( productInfoWrapper ) {
    productInfoWrapper.querySelectorAll( 'input[type=radio]' ).forEach((input) => {
      input.addEventListener( 'change', (event) => {
        if( input.checked ) {
          input.closest( '.product-form__input' ).querySelector( '.form__label-selection' ).innerHTML = input.value;
        }
        if( input.name == 'Size' ) {
          let shoeSizes = '';
          if( input.dataset.mensShoeSizes ) {
            shoeSizes += '<span class="range">' + input.dataset.mensShoeSizes + '</span>';
          }
          if( input.dataset.womensShoeSizes ) {
            shoeSizes += '<span class="range">' + input.dataset.womensShoeSizes + '</span>';
          }
          if( input.dataset.youthShoeSizes ) {
            shoeSizes += '<span class="range">' + input.dataset.youthShoeSizes + '</span>';
          }
          input.closest( '.product-form__input' ).querySelector( '.shoe-size-ranges' ).innerHTML = shoeSizes;
        }
      });
    });
  }
});
/**REMOVE KLAVIYO **/
/*
window.addEventListener("load", (event) => {
  const newsletterSignupForms = document.querySelectorAll( '.newsletter-signup-form' );
  newsletterSignupForms.forEach((form) => {
    let formContainer = form.closest( '.newsletter-signup-container' );
    let errorMessageContainer = form.querySelector( '.error-message' );
    form.addEventListener( 'submit', (event) => {
      event.preventDefault();
      formContainer.classList.remove( 'error-detected' );
      formContainer.classList.remove( 'success-detected' );
      
      let email = form.querySelector( '.email' ).value || '';
      let source = form.dataset.signupSource || '';
      
      const options = {
      method: 'POST',
      headers: {revision: '2023-12-15', 'content-type': 'application/json'},
      body: JSON.stringify({
        data: {
          type: 'subscription',
          attributes: {
            custom_source: source,
            profile: {
              data: {
                type: 'profile',
                attributes: {
                  email: email
                }
              }
            }
          },
          relationships: {list: {data: {type: 'list', id: 'UDJiuC'}}}
        }
      })
    };
    
    fetch('https://a.klaviyo.com/client/subscriptions/?company_id=XyWLG6', options)
      .then(response => {
        if( response.status == 202 ) {
          klaviyo.push(['identify', {
            '$email': email
          }]);
          klaviyo.push(['track', 'Successful Signup Form Submission', {}]);
          formContainer.classList.add( 'success-detected' );
          if (typeof gtag ==="function") {
            gtag("event", "generate_lead", {
              type: "newsletter",
              currency: "USD",
              value: 29.50
            });
          }
          if (typeof fbq === "function") {
            fbq('track', 'Lead', {
              content_category: "Newsletter",
              currency: "USD",
              value: 29.50
            });
          }
          localStorage.setItem( 'newsletter-popup-preventautoopen', 1 );
        } else {
          if( response.status == 400 ) {
            errorMessageContainer.innerHTML = "Please enter a valid email address.";
          } else {
            errorMessageContainer.innerHTML = "Uh oh! Something went wrong. Try again later.";
          }
          formContainer.classList.add( 'error-detected' );
        }
      });
    });
  });
});

var klaviyoIdentified = false;
klaviyo.isIdentified().then( function( data ) {
  klaviyoIdentified = data
});

window.onload = (event) => {
  let options = {
    "openLinkAddress": "open-dialog",
    "openOn": "both",
    "openAutomatically": "delay",
    "openUsers": "both",
    "openLimitId": "newsletter-popup",
    "openDelay": 1,
    "openLimit": 1,
    "openLimitExpiration": "30"
  };

  document.querySelectorAll( '.bc-popup' ).forEach( dialog => {
    dialog.addEventListener( 'click', function( event ) {
      if (event.target === dialog) {
          dialog.close();
      }
    });

    dialog.addEventListener("close", (event) => {
      document.body.style.overflow = "visible";
      if( options.openLimitId ) {
        localStorage.setItem( options.openCountId, parseInt( options.openCount ) + 1 );
        localStorage.setItem( options.lastOpenedId, Date.now() );
      }
    });

    // attach dialog open event handlers to links with the appropriate hrefs
    if( options.openLinkAddress !== '' ) {
      document.querySelectorAll( "[href='" + options.openLinkAddress + "']" ).forEach( link => {
        link.addEventListener( 'click', function( event ) {
          var vw = window.innerWidth;
          if( ( options.openOn === 'desktop' && vw <= 600 ) || ( options.openOn === 'mobile' && vw > 600 ) ) {
            return;
          }
          event.preventDefault();
          dialog.showModal();
        } );
      } );
    }

    // return if the dialog does not have an automatic open setting
    if( ! options.openAutomatically ) {
      return;
    }

    // return if marked for permanent open prevention
    if( localStorage.getItem( options.openLimitId + '-preventautoopen' ) ) {
      return;
    }

    // return if not the correct device
    var vw = window.innerWidth;
    if( ( options.openOn === 'desktop' && vw <= 600 ) || ( options.openOn === 'mobile' && vw > 600 ) ) {
      return;
    }

    // return if identified by Klaviyo
    if( klaviyoIdentified ) {
      return;
    }

    if( options.openLimit ) {
      options.lastOpenedId = options.openLimitId + '-lastopened';
      options.openCountId = options.openLimitId + '-opencount';
      var lastOpened = localStorage.getItem( options.lastOpenedId ) || 0;
      var openLimitExpiration = options.openLimitExpiration;

      //set open count back to zero if it has been long enough since the last open
      if( openLimitExpiration > 0 && ( Date.now() / 1000 ) - ( openLimitExpiration * 86400 ) > lastOpened ) {
        localStorage.setItem( options.openCountId, 0 );
      }
      options.openCount = localStorage.getItem( options.openCountId ) || 0;

      // return if open limit is exceeded
      if( options.openCount >= options.openLimit ) {
        return;
      }
    }

    if( options.openAutomatically === 'delay' ) {
      setTimeout( function() {
        openDialog( dialog, options );
      }, options.openDelay * 1000 );
    }
  } );

  document.querySelectorAll( '.bc-popup__close' ).forEach( el => {
    var event = 'click';
    if( el.tagName.toLowerCase() === 'form' ) { // change close event to submit if it's a form
      event = 'submit';
    }

    el.addEventListener( event, function( event ) {
      el.closest( 'dialog' ).close();
      if( el.getAttribute( 'href' ) === '#' ) {
        event.preventDefault();
      }
    } );
  } );

  document.querySelectorAll( '.prevent-dialog-auto-open' ).forEach( el => {
    var event = 'click';
    if( el.tagName.toLowerCase() === 'form' ) { // change close event to submit if it's a form
      event = 'submit';
    }

    el.addEventListener( event, function( event ) {
      var dialog = el.closest( 'dialog' );
      var options = JSON.parse( dialog.dataset.options );
      preventDialogAutoOpen( options.openLimitId );
      if( el.getAttribute( 'href' ) === '#' ) {
        event.preventDefault();
      }
    } );
  } );
}

function openDialog( dialog, options ) {
  if( ! dialog.open ) {
    document.body.style.overflow = "hidden";
    dialog.showModal();
  }
}

function preventDialogAutoOpen( openLimitId ) {
  localStorage.setItem( openLimitId + '-preventautoopen', 1 );
}
  */